import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const navLinks = [
  { label: "Come Funziona", href: "#come-funziona" },
  { label: "Prezzi", href: "#prezzi" },
  { label: "Testimonianze", href: "#testimonianze" },
  { label: "FAQ", href: "#faq" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "glass-warm shadow-soft py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center gap-1.5 group">
          <span className="font-serif text-2xl font-bold text-foreground tracking-tight">Io</span>
          <span className="font-serif text-2xl font-bold text-accent">Ci</span>
          <span className="font-serif text-2xl font-bold text-foreground tracking-tight">Sono</span>
          <span className="text-xs text-muted-foreground font-sans ml-0.5">.org</span>
        </a>

        {/* Desktop links */}
        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Desktop CTA */}
        <div className="hidden lg:block">
          <Button variant="premium" size="default" asChild>
            <Link to="/register">Inizia Ora</Link>
          </Button>
        </div>

        {/* Mobile menu */}
        <div className="lg:hidden">
          <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon"><Menu className="w-5 h-5" /></Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-80 bg-background border-border">
              <div className="flex flex-col gap-6 mt-8">
                <a href="#" className="flex items-center gap-1">
                  <span className="font-serif text-xl font-bold text-foreground">Io</span>
                  <span className="font-serif text-xl font-bold text-accent">Ci</span>
                  <span className="font-serif text-xl font-bold text-foreground">Sono</span>
                  <span className="text-xs text-muted-foreground font-sans">.org</span>
                </a>
                <div className="flex flex-col gap-4">
                  {navLinks.map((link) => (
                    <a key={link.href} href={link.href} onClick={() => setMobileOpen(false)}
                      className="text-base font-medium text-muted-foreground hover:text-foreground transition-colors duration-300 py-2 border-b border-border/50">
                      {link.label}
                    </a>
                  ))}
                </div>
                <Button variant="premium" size="lg" className="mt-4" asChild>
                  <Link to="/register">Inizia Ora</Link>
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </motion.nav>
  );
};
